import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {ReceivablesBalance} from "../../../shared/interface/receivables-balance";
import {ReplaySubject} from "rxjs";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {ReceivablesBalanceService} from "../../../shared/services/receivables-balance.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {delay, takeUntil} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {Terminals} from "../../../shared/interface/terminals";
import {TerminalsService} from "../../../shared/services/terminals.service";

export interface ReceivablesBalanceNoteDialogData {
  terminals: Terminals;
}

@Component({
  selector: 'app-terminals-note-add',
  templateUrl: './terminals-note-add.component.html',
  styleUrls: ['./terminals-note-add.component.scss']
})
export class TerminalsNoteAddComponent implements OnInit, OnDestroy {

  noteForm: FormGroup;
  terminalsObject: Terminals;
  processingRequest = false;
  noteControl: FormControl;
  enableSaveButton = false;


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    public dialogRef: MatDialogRef<TerminalsNoteAddComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ReceivablesBalanceNoteDialogData,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
    private terminalsService: TerminalsService,
    private snack: MatSnackBar,
  ) {
    this.terminalsObject = data.terminals;
    this.noteForm = fb.group({
      note: this.noteControl = fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.noteForm.valueChanges
      .pipe(
        delay(0),
        takeUntil(this.destroyed$)
      )
      .subscribe(() => this.enableSaveButton = this.noteForm.valid);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  sendForm(): void {
    this.processingRequest = true;

    this.terminalsService.sendNote(this.noteForm.value, this.terminalsObject.uuid)
      .subscribe(() => {
        this.snack.open('Pomyślnie dodano notatkę', '', {
          duration: 2000,
        });
        this.processingRequest = false;
        this.dialogRef.close();
      }, (error: HttpErrorResponse) => {
        this.processingRequest = false;
        this.snack.open('Podczas dodawania notatki  wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });


      })
    ;
  }
  closeDialog(e): void {
    this.dialogRef.close(e);
  }

}
